import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { DuplicateVehicleDialogComponent } from '../duplicate-vehicle-dialog/duplicate-vehicle-dialog.component';
import { CalculationService, DataService, DateService, HelperService, HTTPService } from 'app/services';
import { config, messages, mileageUnits, vehicleTransmissions } from 'app/constants';

import { Subscription } from 'rxjs';
import { debounce, find, sortBy, map, trim } from 'lodash';
import { TransferVehicleDialogComponent } from '../transfer-vehicle-dialog/transfer-vehicle-dialog.component';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { CreateMyFleetCustomerDialogComponent } from '../create-myfleet-customer-dialog/create-myfleet-customer-dialog.component';
import { datetimeFormat } from 'app/constants/date-time-format';

@Component({
  selector: 'app-vehicle-add',
  templateUrl: './vehicle-add.component.html',
  styleUrls: ['./vehicle-add.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService],
  animations: [
    trigger('toggleBox', [
      state(
        'open',
        style({
          height: '150px',
        }),
      ),
      state(
        'closed',
        style({
          height: '0px',
        }),
      ),
      transition('open => closed', [animate('.3s')]),
      transition('closed => open', [animate('0.3s')]),
    ]),
    trigger('toggleBoxNew', [
      state('openNew', style({})),
      state(
        'closedNew',
        style({
          height: '0px',
        }),
      ),
      transition('openNew => closedNew', [animate('.3s')]),
      transition('closedNew => openNew', [animate('0.3s')]),
    ]),
  ],
})
export class VehicleAddComponent implements OnInit, OnDestroy {
  @Input('onSubmitData')
  set onSubmitData(data: any) {
    if (data && data.active === 'add-vehicle') {
      this.onSubmit();
    }
  }
  @Input('onProceedData')
  set collectObjectToSave(data: any) {
    if (data && data.active === 'add-vehicle') {
      this.onProceed();
    }
  }
  @Input('inputCustomer')
  set inputCustomer(customer: any) {
    if (customer && customer._id) {
      this.customer = customer;
      this.query.customer = this.customer.fullName;
      this.customerSearchDisabled = true;
      if (customer._id) {
        this.getCustomer(customer._id);
        this.errors.customer = '';
      }
      if (customer.vehicleNameForCreate) this.vehicleNameForCreate = customer.vehicleNameForCreate;
      this.errors.year = '';
      this.setState();
    }
  }
  @Input('company')
  set company(company: any) {
    if (!company) {
      return;
    }

    if (company.address) {
      if (company.address.state) {
        this.defaultRegState = company.address.state;
        this.defaultRegStateCode = company.address.stateCode;

        if (this.defaultRegState) {
          this.vehicle.registrationState = this.defaultRegState;
          this.vehicle.registrationStateCode = this.defaultRegStateCode;
        }

        this.hasStateValueFilled = true;
        this.validateMotorAndSearch();
      }

      this.companyCountry = this.dataService.locationAddress.country || company.address.country === 'Canada' ? 'CA' : 'USA';
      this.getStates();
    }

    if (company.appsettings) {
      this.isCarfaxEnabled = company.appsettings.carfaxConnected;
      this.isMotorLookupEnabled = company.appsettings.isMotorLookupEnabled;

      if (!this.isCreateVehicleMode && !this.isCarfaxEnabled && !this.isMotorLookupEnabled) this.isCreateVehicleMode = true;
      if (company.appsettings.mileageMeasuringUnit) {
        this.defaultMileageUnit = company.appsettings.mileageMeasuringUnit;
      } else if (company.address && company.address.country === 'Canada') {
        this.defaultMileageUnit = 'km';
      } else {
        this.defaultMileageUnit = 'mi';
      }

      if (this.isCarfaxEnabled) {
        this.vehicleSearchPlaceholder = 'Search license plate, VIN, or year, make, model';
      }
    }
  }
  @Input('isCreateMode')
  set isCreateMode(isCreateMode) {
    if (this.isCreateVehicleMode && !isCreateMode) {
      this.isCreateVehicleMode = false;
    }
  }
  @Input() openFrom: string = '';
  @Input() from: string = '';
  @Input() isProcessing: boolean;
  @Input() vehicleNameForCreate: string = '';
  @Input() setProcessingState: any;
  @Input() isOpenFromCreateCustomer = false;
  @Input() vehicleOnCart = null;
  @Input() onlineOrderSource = '';

  @Output() vehicleCreated = new EventEmitter();
  @Output() createCustomer = new EventEmitter();
  @Output() vehicleCreatedForOther = new EventEmitter();
  @Output() cancelCreatedForOther = new EventEmitter();
  @Output() closeDialog = new EventEmitter();
  @Output() vehicleProcessingMode = new EventEmitter();
  @Output() onProceedQuickTireLookup = new EventEmitter();

  @ViewChild('addVehicleForm', { static: true }) addVehicleForm;

  source: string;
  isOpen: boolean = false;
  isStateSearching: boolean = false;
  isCreateVehicleMode: boolean = false;
  customerSearchDisabled: boolean = false;
  vehicleSearchDisabled: boolean = false;
  isLoading: boolean = false;
  vinInputVisible: boolean = false;
  licenseInputVisible: boolean = false;

  validate: any = {};
  vehicleQuery: string = '';
  customer: any = {};
  vehicle: any = {};
  customerVehicle: any = {};
  apiResponse: any = null;
  config = config;

  driverTypes: any[] = [];
  vehicleColors: any[] = [];
  transmissions: any[] = vehicleTransmissions;
  mileageUnits: any[] = mileageUnits;
  stateResults: any[] = [];
  defaultMileageUnit: string = '';
  defaultRegState: string = '';
  defaultRegStateCode: string = '';

  searchType: any = '';
  customerSuggestions: any[] = [];
  vehicleSuggestions: any[] = [];
  vehicleType: any = { active: [], inactive: [] };
  orders: any[] = [];
  customerVehicleSuggestions: any[] = [];
  customerVehicleType: any = { active: [], inactive: [] };
  driverTypeSuggestions: any[] = [];
  vehicleColorsSuggestions: any[] = [];
  dataServiceSub: Subscription;
  vehicleSearchPlaceholder: string = 'Search VIN or year, make, model';
  focus: any = {};
  errors: any = {};
  query: any = {};
  states: any[] = [];
  companyCountry: string = '';
  isCarfaxEnabled: boolean = false;
  isMotorLookupEnabled: boolean = false;
  disabled: any = {};
  isVehicleNameUnique: boolean = true;
  vehicleTags: any[] = [];
  hasStateValueFilled: boolean = false;
  searchingVehicles: boolean = false;
  isSearched: boolean = true;
  vinExsistErrMsg = '';
  lincencePlateErrMsg = '';
  vehicleAlreadyAdded = false;
  customerList: any = [];
  isDuplicateVehicle: boolean = false;
  selectedVehicle: any = [];
  type: any = '';
  isTransferVehicleEnabled: boolean = false;
  isMileageMandatory: boolean = false;
  isRegStateMandatory: boolean = false;
  isLicensePlateMandatory: boolean = false;
  currentCustomer: any = {};
  estimateId: string = 'new-ro';
  selectedVehicleTireSizes: any = [];
  isShowNoRecordForceFully: boolean = false;
  selecteEstimateTax: any = {};
  isSearching: boolean = false;
  triggerSearchAfterResponse: boolean = false;
  fieldPlaceholder = {
    licensePlate: 'License Plate',
    regState: 'Registration State',
  };

  constructor(
    private httpService: HTTPService,
    public helperService: HelperService,
    public ref: DynamicDialogRef,
    public dConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    private dataService: DataService,
    private dateService: DateService,
    private calculationService: CalculationService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.getTags();
    this.setFeatureFlags();

    /**
     * This subscribe is called from the following
     * - add-dialog.component
     */
    this.dataServiceSub = this.dataService.getData().subscribe((obj) => {
      const data = obj.data;

      if (data.type === 'passdata' && data.key === 'clear-search-data') {
        this.query.customer = '';
      }
      if (data.key === 'company-appdata-updated') {
        this.setFeatureFlags();
      }
    });

    if (this.vehicleNameForCreate) {
      this.handleChange('vehicle', this.vehicleNameForCreate);
      this.isSearched = false;
      this.validateMotorAndSearch();
    }
  }

  ngOnDestroy() {
    if (this.dataServiceSub) {
      this.dataServiceSub.unsubscribe();
    }
  }

  setFeatureFlags() {
    this.isTransferVehicleEnabled = this.dataService.isTransferVehicleEnabled;

    if (this.dataService.isCustomerVehicleMandatoryFieldsEnabled) {
      this.isRegStateMandatory = this.dataService.isRegStateMandatory;
      this.isLicensePlateMandatory = this.dataService.isLicensePlateMandatory;
    }

    this.fieldPlaceholder.licensePlate = `License Plate${this.isLicensePlateMandatory ? '*' : ''}`;
    this.fieldPlaceholder.regState = `Registration State${this.isRegStateMandatory ? '*' : ''}`;
  }

  validateMotorAndSearch() {
    if (this.vehicleNameForCreate && this.vehicleNameForCreate.length >= 3) {
      this.focus.vehicle = true;
      this.vehicle.title = this.vehicleNameForCreate;

      if (!this.vehicle.registrationStateCode) {
        if (!this.defaultRegStateCode) {
          this.hasStateValueFilled = false;
        } else {
          this.hasStateValueFilled = true;
        }
      } else {
        this.hasStateValueFilled = true;
      }

      if (this.hasStateValueFilled && !this.isSearched) {
        this.isSearched = true;
        this.onSearchVehicle(this.vehicleNameForCreate);
      } else {
        this.isSearched = false;
      }
    }
  }

  getStates() {
    this.httpService.stateSearch({ search: '' }).then(
      (res) => {
        const states = sortBy((res && res.states) || [], 'state');
        const canada = [{ isHeader: true, country: 'Canada' }];
        const usa = [{ isHeader: true, country: 'USA' }];

        if (states.length) {
          states.forEach((state: any) => {
            if (state.country === 'CA') {
              canada.push(state);
            } else {
              usa.push(state);
            }
          });

          if (this.companyCountry === 'CA') {
            this.states = [...canada, ...usa];
          } else {
            this.states = [...usa, ...canada];
          }

          this.setState();
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  getDriverTypes() {
    this.httpService.getTags(config.category.driveType).then(
      (driverTypes: any[]) => {
        if (driverTypes && driverTypes.length) {
          this.driverTypes = driverTypes;
          this.driverTypeSuggestions = [...driverTypes];
        }
      },
      (error) => {
        this.helperService.showToaster('error', error);
      },
    );
  }

  handleTagDelete(deletedTag: any) {
    if (this.vehicleTags && this.vehicleTags.length) {
      this.vehicleTags = this.vehicleTags.filter(tag => {
        if (deletedTag._id) {
          return tag._id !== deletedTag._id;
        } else {
          return !(tag.name === deletedTag.name && tag.color === deletedTag.color);
        }
      });
    }
  }

  getCustomer(customerId: string) {
    this.httpService
      .getCustomer(customerId, {
        // selectedField: 'isFleetCustomer isMFCustomer'
      })
      .then(
        // this.httpService.getCustomer(customerId, { selectedField: 'isFleetCustomer' }).then(
        (customer) => {
          // this.customer.isFleetCustomer = customer
          customer.contactOnEmail = this.customer.contactOnEmail || customer.contactOnEmail;
          customer.contactOnPhone = this.customer.contactOnPhone || customer.contactOnPhone;
          this.customer = customer;
          this.customer.fullName = customer.fullNameQBO || customer.fullName;
          if (this.customer?._id) {
            this.focus.vehicle = true;
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      );
  }

  /** Fetch all vehicle color tags */
  getVehicleColors() {
    this.httpService.getTags(config.category.vehicleColor).then(
      (colors: any[]) => {
        if (colors && colors.length) {
          this.vehicleColors = colors;
          this.vehicleColorsSuggestions = [...colors];
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  getTags() {
    this.httpService.getMultipleTags([config.category.vehicle, config.category.vehicleColor, config.category.driveType]).then(
      (results: any[]) => {
        if (results && results.length) {
          results.forEach((tag) => {
            if (tag.type === config.category.vehicle) {
              this.vehicleTags.push(tag);
            } else if (tag.type === config.category.vehicleColor) {
              this.vehicleColors.push(tag);
            } else if (tag.type === config.category.driveType) {
              this.driverTypes.push(tag);
            }
          });
          this.vehicleTags = [...this.vehicleTags];
          this.driverTypeSuggestions = [...this.driverTypes];
          this.vehicleColorsSuggestions = [...this.vehicleColors];
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  handleShowMoreToggle() {
    this.isOpen = !this.isOpen;
  }

  /** Getting data from the autocomplete input */
  handleChange(type: string, value: string) {
    this.vehicle[type] = value;
    this.query[type] = value;

    if (type === 'vehicleName') {
      this.checkVehicleNameUniqueness();
    }

    if (type === 'vin') {
      this.vinInputVisible = true;
    }

    if (type === 'licensePlateNo') {
      this.licenseInputVisible = true;
      this.errors[type] = '';
    }
  }

  handleFocus(type: string) {
    this.focus[type] = true;

    if (type !== 'vin') {
      this.errors[type] = '';
    }

    if (type === 'driverType') {
      this.onSearchDriverType(this.query.driverType);
    }

    if (type === 'color') {
      this.onSearchDriverType(this.query.color);
    }

    if (type === 'vin') {
      this.vinInputVisible = true;
    }

    if (this.from === 'quick-tire-lookup' && type !== 'quickTireSection') {
      this.focus.quickTireSection = false;
    }
  }

  handleRadioChange(value: string, event: any) {
    this.estimateId = value;
    if (this.estimateId !== 'new-ro') {
      const selectedEstimate = find(this.orders, { orderId: this.estimateId });
      if (selectedEstimate?.tax) {
        this.selecteEstimateTax = selectedEstimate?.tax;
      }
    } else {
      this.selecteEstimateTax = {};
    }
    this.handleFocus('quickTireSection');
  }

  handleBlur(type: string) {
    this.focus[type] = false;
    if (type === 'vin') {
      if (this.vinExsistErrMsg) {
        this.vinInputVisible = true;
      } else {
        this.vinInputVisible = false;
      }
    }

    if (type === 'licensePlateNo') {
      this.licenseInputVisible = false;
    }

    if (type === 'vehicleName') {
      this.checkVehicleNameUniqueness();
    }

    if (this.from === 'quick-tire-lookup' && type !== 'quickTireSection') {
      this.focus.quickTireSection = false;
    }
  }

  onFocusVin() {
    if (!this.disabled?.vin) {
      this.vinInputVisible = true;
      this.cdr.detectChanges();
    }
  }

  checkVehicleNameUniqueness = debounce(() => {
    if (!this.vehicle.vehicleName || !this.customer._id) {
      return;
    }

    if (this.helperService.trimString(this.vehicle.vehicleName) === this.helperService.trimString(this.vehicle.name)) {
      this.errors.vehicleName = '';
      this.isVehicleNameUnique = true;
      return;
    }

    this.httpService.isVehicleNameUnique({ customerId: this.customer._id, vehicleName: this.vehicle.vehicleName }).then(
      ({ isUnique }) => {
        this.isVehicleNameUnique = isUnique;
        this.errors.vehicleName = '';

        if (!this.isVehicleNameUnique) {
          this.errors.vehicleName = `This vehicle name exists for this customer`;
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }, 400);

  openCreateCustomer() {
    this.createCustomer.emit({
      context: 'add-vehicle',
      fullName: this.query.customer,
    });
  }

  openCreateVehicle(isOpenFromQuoteLookup: boolean = false) {
    this.isCreateVehicleMode = true;
    this.focus.vehicle = false;

    if (isOpenFromQuoteLookup) {
      this.orders = [];
      this.customerVehicle = {};
      this.focus.vehicle = true;
      this.isProcessing = false;
      this.onSearchVehicle(this.query.vehicle || '');
      this.vehicleProcessingMode.emit(true);
    }
  }

  cancelCreated() {
    this.cancelCreatedForOther.emit({
      openFrom: this.openFrom,
    });
  }

  /** On customer select */
  onCustomerSelect(customer: any) {
    if (!this.customerSearchDisabled) {
      this.errors.customer = '';
      this.customer = customer;
      this.customer.fullName = this.customer.fullNameQBO;
      this.focus.vehicle = true;
      this.isDuplicateVehicle = false;
      this.checkVehicleNameUniqueness();

      if (this.from === 'quick-tire-lookup') {
        if (this.vehicleOnCart?.Year) {
          this.resetPayload();
          if (this.customer.vehicles && this.customer.vehicles.length) {
            this.customer.vehicles = [];
          }
          if (this.vehicleOnCart?.VIN) {
            this.query.vehicle = this.vehicleOnCart.VIN;
          } else {
            this.query.vehicle = [this.vehicleOnCart.Year, this.vehicleOnCart.MakeName, this.vehicleOnCart.ModelName, this.vehicleOnCart.SubModelName].filter((str) => str).join(' ');
          }
          // initially sent the empty search array to load all the customer vehicles same as on RO
          this.onSearchCustomerVehicle(this.query.vehicle, true);
        } else if (customer?.vehicles?.length) {
          this.onSearchCustomerVehicle(this.query?.vehicle || '', true);
        }
      }

      if (this.customer.isMFCustomer) {
        this.handleOpenFleetCustomer();
      }

      this.setState();
    }
  }

  resetPayload() {
    this.estimateId = 'new-ro';
    this.customerVehicle = {};
  }

  setState() {
    if (this.customer?.address?.country) {
      this.stateResults = this.states.filter(({ isHeader, country }) => !isHeader && country === this.customer?.address?.country);
    } else {
      this.stateResults = this.states.filter(({ isHeader }) => !isHeader);
    }
  }

  onCustomerVehicleSelect(vehicle: any, close?: any) {
    if (close) close();
    this.resetPayload();
    this.customerVehicle = vehicle;

    if (this.query?.vehicle) {
      this.query.vehicle = '';
    }

    if (this.customer?._id && this.customerVehicle?._id) {
      this.httpService.getOrderByCustVehicle(this.customer._id, this.customerVehicle._id).then(
        (orders) => {
          this.orders = orders;
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      );
    }
    if (vehicle && vehicle.apiResponse) {
      const vehicleObj: any = {
        vehicleBaseId: vehicle.apiResponse.BaseVehicleID,
        EN: vehicle.apiResponse.EngineID,
        CO: vehicle.apiResponse.CountryID,
        SM: vehicle.apiResponse.SubModelID,
      };
      this.getRecommendedTireSizes(vehicleObj);
    }
  }

  onTransmissionSelect(value: string) {
    this.vehicle.transmission = value;
  }

  onMileageUnitSelect(value: any) {
    if (this.vehicle.mileageMeasuringUnit && this.vehicle.mileageMeasuringUnit.value === value.value) {
      return;
    }
    this.vehicle.mileage = this.calculationService.convertMileageIntoUnit(this.vehicle.mileage, value.value);
    this.vehicle.mileageMeasuringUnit = value;
  }

  /** On vehicle select */
  onVehicleSelect(vehicle: any, close: any = null) {
    if (!this.vehicleSearchDisabled && vehicle.Year && vehicle.MakeName) {
      if (this.vehicle.connectedVia !== 'vin') {
        this.vehicle.vin = '';
      }
      this.errors.vehicle = '';
      this.errors = {};
      this.vehicle = {
        ...this.vehicle,
        ...this.helperService.setVehicleConnectedMotorData(vehicle, this.searchType, this.vehicleQuery),
      };

      // check if wants to create new drive type or not
      if (this.vehicle?.driveType?.name) {
        this.onCreateDriverType({ name: this.vehicle.driveType.name, showError: false, isForFurtureUse: false });
      }
      this.vehicle.vehicleName = this.vehicle.name;
      this.checkVehicleNameUniqueness();

      const companyData = this.helperService.getCompany();
      const eventName = 'Vehicle Found - Motor';
      const date = new Date();
      // const source = this.source.toLowerCase() === 'motor 5.0' ?
      // 'Motor Primary' : this.source.toLowerCase() === 'motor 4.5' ?
      // 'Motor Secondary' : 'Motor Primary & Secondary';
      const payload = {
        // source,
        tenantName: companyData.companyName,
        date: this.dateService.formatDate(date, datetimeFormat.mmmyyyy),
        time: this.dateService.getTime(date),
      };
      // this.helperService.postGainsightPXEvent(eventName, payload);

      this.disabled = this.helperService.setVehicleDisabledFields(true, this.vehicle.isCarfaxConnected, this.vehicle.connectedVia);
    }

    this.isDuplicateVehicle = false;
    this.apiResponse = vehicle;

    if (close) close();
    this.openCreateVehicle();
  }

  getRecommendedTireSizes(selectedVehicle: string) {
    this.selectedVehicleTireSizes = [];
    this.httpService.getVehicleRecomendedParts(selectedVehicle, { fetchSizes: true }).then(
      (res: any) => {
        if (res && res.sizes && res.sizes.length) {
          this.selectedVehicleTireSizes = res.sizes;
        }
      },
      (err: any) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  onDriverTypeSelect(driveType: any) {
    this.vehicle.driveType = driveType;
  }

  onVehicleColorSelect(vehicleColor) {
    this.vehicle.color = vehicleColor;
  }

  onSearchDriverType(value: string) {
    if (value) {
      const query = value.toLowerCase();
      this.driverTypeSuggestions = this.driverTypes.filter(({ name }) => name && name.toLowerCase().includes(query));
    }
  }

  onSearchVehicleColor(value: string) {
    const query = value.toLowerCase();
    this.vehicleColorsSuggestions = this.vehicleColors.filter(({ name }) => name && name.toLowerCase().includes(query));
  }

  /** On vehicle search */
  async onSearchVehicle(query: string) {
    this.vehicleQuery = query;

    this.vehicleType = { active: [], inactive: [] };

    if (this.isSearching) {
      this.triggerSearchAfterResponse = true;
      return;
    }
    this.searchingVehicles = true;
    this.isLoading = true;
    this.isSearching = true;

    try {
      const result: any = await this.httpService.searchInAllMotorGens(query.toLowerCase(), this.vehicle.registrationStateCode || this.defaultRegStateCode);

      if (result) {
        if (result.Source != '') {
          this.source = result?.Source;
        }
        this.vehicleSuggestions = [...result.Vehicles.map((vehicle: any) => this.helperService.setVehicleMotorSearchResults(vehicle, this.vehicleQuery))];
        this.vehicleSuggestions = sortBy(this.vehicleSuggestions, 'name');
        this.vehicleSuggestions.map((val) => {
          this.vehicleType.active.push(val);
        });
        this.searchType = result.SearchType;
        this.isLoading = false;
        this.isSearched = true;

        this.scrollToBottom();
        this.searchingVehicles = false;
        this.isLoading = false;
        this.isSearching = false;

        if (this.dataService.isGainSightPXEnabled && result?.Vehicles?.length) {
          const source = result?.Source;
          const eventName = 'Vehicle Search';
          const payload = {
            source,
          };
          this.helperService.postGainsightPXEvent(eventName, payload);
        }

        if (this.triggerSearchAfterResponse) {
          this.triggerSearchAfterResponse = false;
          this.onSearchVehicle(this.vehicleQuery);
        }
      }
    } catch (err) {
      this.searchingVehicles = false;
      this.isLoading = false;
      this.isSearching = false;
      this.helperService.showToaster('error', err);
    }
  }

  async onSearchCustomerVehicle(query: string, isFromCustomerSelect?: boolean) {
    if (this.customer?._id) {
      this.isShowNoRecordForceFully = false;
      this.customerVehicleType = { active: [], inactive: [] };
      this.isLoading = true;
      this.httpService
        .getCustomerVehicle(this.customer._id, { fetchTags: false, needPagination: false, search: query })
        .then(
          ({ vehicles }: any) => {
            if (vehicles && vehicles.length >= 0) {
              vehicles.map((val) => {
                if (val.isActive) {
                  this.customerVehicleType.active.push(val);
                } else {
                  this.customerVehicleType.inactive.push(val);
                }
              });
              this.customerVehicleSuggestions = [...vehicles];
            }

            if (isFromCustomerSelect) {
              this.focus.vehicle = true;
              this.focus.customer = false;
              this.isShowNoRecordForceFully = this.customerVehicleSuggestions && this.customerVehicleSuggestions?.length === 0;
            } else {
              this.isShowNoRecordForceFully = false;
            }

            this.cdr.detectChanges();
          },
          (err) => {
            this.helperService.showToaster('error', err);
          },
        )
        .finally(() => {
          this.isLoading = false;
        });
    }
  }

  openCustomerSidepanel(customer: any, vehicle: any) {
    customer.vehicleId = vehicle._id;
    customer.openConnectMotor = true;
    customer.openConflictDialog = true;
    this.dataService.sendData(this.dataService.typeSidebar('vehicle', customer.customerId, customer.fullName, customer));
  }

  /** On customer search */
  onSearchCustomer(query: string) {
    const hasScrollAlready = +42;
    this.isLoading = true;
    this.httpService.searchCustomer(trim(query), { populateTaxCodeOverRide: true, populatePricing: true, limit: 50 }).then(
      (customer: any[]) => {
        this.customerSuggestions = customer;
        this.isLoading = false;
        this.scrollToTop(hasScrollAlready);
      },
      (err) => {
        this.isLoading = false;
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      },
    );
  }

  /** Clear search suggestion */
  onSuggestionsClear(type: string) {
    this.isDuplicateVehicle = false;
    this.errors.vin = '';
    this.errors.licensePlateNo = '';

    if (type === 'customer') {
      this.customerSuggestions = [];
    }

    if (type === 'vehicle') {
      this.vehicleSuggestions = [];
    }

    if (type === 'customerVehicle') {
      this.customerVehicleSuggestions = [];
      this.onSearchCustomerVehicle('');
    }

    if (type === 'driverType') {
      this.driverTypeSuggestions = [...this.driverTypes];
    }

    this.query[type] = '';
  }

  clearSelectItem(type: string) {
    if (type === 'customer') {
      this.customer = {};
      this.focus.customer = true;
    }

    if (type === 'vehicle') {
      this.vehicle = {};
      this.isCreateVehicleMode = false;
      this.focus.vehicle = true;
    }
  }

  onCreateDriverType({ name, isForFurtureUse, showError = true }) {
    if (name) {
      const trimmedName = name.trim();
      const duplicate = this.driverTypeSuggestions.some((type) => type.name.toLowerCase() === trimmedName.toLowerCase());

      if (duplicate) {
        if (showError) this.helperService.showToaster('error', 'Drive type already exists.');
        return;
      }

      this.httpService
        .createTag({
          name: trimmedName,
          isForFurtureUse,
          type: config.category.driveType,
        })
        .then(
          (driverType) => {
            this.driverTypes.push(driverType);
            this.driverTypeSuggestions.push(driverType);
            this.onDriverTypeSelect(driverType);
          },
          (err) => {
            this.helperService.showToaster('error', err);
          },
        );
    }
  }

  onVehicleColorCreate({ name, isForFurtureUse }) {
    if (name) {
      this.httpService
        .createTag({
          name: name.trim(),
          isForFurtureUse,
          type: this.config.category.vehicleColor,
        })
        .then(
          (vehicleColor) => {
            this.vehicleColors.push(vehicleColor);
            this.vehicleColorsSuggestions.push(vehicleColor);
            this.onVehicleColorSelect(vehicleColor);
          },
          (error) => {
            this.helperService.showToaster('error', error);
          },
        );
    }
  }

  validation(): boolean {
    let isValid = true;

    if (this.customer._id) {
      this.errors.customer = '';
    } else {
      this.errors.customer = 'Customer Required';
      isValid = false;
    }

    if (this.customerVehicle?._id || (this.vehicle && Object.keys(this.vehicle)?.length > 1)) {
      this.errors.vehicle = '';
    } else {
      this.errors.vehicle = 'Vehicle Required';
      isValid = false;
    }

    if (this.customerVehicle?._id || this.vehicle.year) {
      this.errors.year = '';
    } else {
      this.errors.year = 'Year Required';
      isValid = false;
    }

    if (this.isLicensePlateMandatory) {
      this.errors.licensePlateNo = '';
      if (!this.vehicle.licensePlateNo) {
        if (!(this.from === 'quick-tire-lookup' && !this.isCreateVehicleMode)) {
          this.errors.licensePlateNo = 'License Plate Required';
          isValid = false;
        }
      }
    }

    if (this.isRegStateMandatory) {
      this.errors.registrationState = '';
      if (!this.vehicle.registrationState) {
        if (!(this.from === 'quick-tire-lookup' && !this.isCreateVehicleMode)) {
          this.errors.registrationState = 'Registration State Required';
          isValid = false;
        }
      }
    }

    if (this.customerVehicle?._id || this.vehicle.year) {
      this.errors.year = '';
    } else {
      this.errors.year = 'Year Required';
      isValid = false;
    }

    if (!this.customerVehicle?._id) {
      if (!this.vehicle.vehicleName) {
        this.errors.vehicleName = 'Vehicle required';
        isValid = false;
      } else if (this.isVehicleNameUnique) {
        this.errors.vehicleName = '';
      } else {
        this.errors.vehicleName = 'This vehicle name exists for this customer';
        isValid = false;
      }
    }

    return isValid;
  }

  onSubmit() {
    if (this.validation()) {
      const vehicle = this.createVehicleObject();

      if (!this.isDuplicateVehicle) {
        this.createVehicle(vehicle);
      } else if (this.isDuplicateVehicle) {
        if (this.type === 'newVehicle') {
          vehicle.vehicleCheck = false;
          this.createVehicle(vehicle);
        } else if (this.type === 'updateVehicle') {
          this.isDuplicateVehicle = true;
        }
      }
    }
  }

  createVehicleObject() {
    const odm = [];

    if (this.vehicle.mileage) {
      if (!this.vehicle.mileageMeasuringUnit || (this.vehicle.mileageMeasuringUnit && !this.vehicle.mileageMeasuringUnit.value)) {
        this.vehicle.mileageMeasuringUnit = find(this.mileageUnits, {
          value: this.defaultMileageUnit,
        });
      }

      odm.push({
        reading: this.vehicle.mileage,
        readingDate: this.dateService.currentDate(),
        mileageMeasuringUnit: this.vehicle.mileageMeasuringUnit.value,
      });
    }

    if (this.vehicle.licensePlateNo && !this.vehicle.registrationStateCode) {
      this.vehicle.registrationState = this.defaultRegState;
      this.vehicle.registrationStateCode = this.defaultRegStateCode;
      this.hasStateValueFilled = true;
    }

    let {
      vin,
      year,
      make,
      model,
      color,
      notes,
      engine,
      driveType,
      vehicleName,
      transmission,
      connectedVia,
      licensePlateNo,
      isCarfaxConnected,
      registrationState,
      registrationStateCode,
      tags,
      vehicleCheck,
    } = this.vehicle;

    if (transmission?.value) {
      const possibleTransmissions = ['', 'automatic', 'manual'];
      const isValid = possibleTransmissions.includes(transmission.value);
      if (!isValid) {
        transmission = { ...transmission, value: '' };
      }
    } else {
      transmission = { ...transmission, value: '' };
    }

    const vehicle = {
      name: `${year || ''} ${make || ''} ${model || ''}`,
      vehicleName,
      VIN: vin,
      plate: '',
      year: year,
      make: make,
      ODM: odm,
      trim: '',
      model: model,
      connectedVia,
      notes: notes,
      bodyStyle: '',
      licensePlateNo,
      engine: engine,
      isMotorConnected: false,
      isCarfaxConnected: false,
      color: color && color.name,
      apiResponse: this.apiResponse,
      customerId: this.customer._id,
      customerName: this.customer.fullName,
      registrationState: registrationState,
      driveType: driveType && driveType.name,
      registrationStateCode: registrationStateCode,
      transmission: transmission && transmission.value,
      vehicleCheck: true,
      tags,
    };

    if (isCarfaxConnected) {
      vehicle.isCarfaxConnected = true;
    }

    if (vehicle.apiResponse && vehicle.apiResponse.BaseVehicleID) {
      vehicle.isMotorConnected = true;
    }

    return vehicle;
  }

  openDuplicateVehicleModal() {
    const ref = this.dialogService.open(DuplicateVehicleDialogComponent, {
      width: '500px',
      styleClass: 'add-dialog',
      showHeader: false,
      data: {
        customerList: this.customerList,
        customerId: this.customer._id,
        vehicleName: this.vehicle.title,
        isShow: false,
      },
    });

    const onClose = ref.onClose.subscribe((data) => {
      if (data.type === 'newVehicle') {
        this.type = data.type;
        this.selectedVehicle = [];
        this.selectedVehicle = data.selectedVehicle;
        this.isDuplicateVehicle = true;
        this.errors.vin = '';
        this.errors.licensePlateNo = '';
        this.onSubmit();
        onClose.unsubscribe();
      } else if (data.type === 'close') {
        onClose.unsubscribe();
      } else if (data.type === 'updateVehicle') {
        if (data.selectedVehicle) {
          onClose.unsubscribe();
          this.customer.fullName = data.selectedVehicle.customerName;

          if (this.from === 'quick-tire-lookup') {
            this.vehicle = {
              ODM: data.selectedVehicle.ODM,
              VIN: data.selectedVehicle.VIN,
              apiResponse: data.selectedVehicle.apiResponse,
              color: { name: data.selectedVehicle.color || '' },
              connectedVia: data.selectedVehicle.connectedVia,
              customerId: data.selectedVehicle.customerId,
              _id: data.selectedVehicle._id,
              driveType: { name: data.selectedVehicle.driveType || '' },
              engine: data.selectedVehicle.engine,
              isActive: data.selectedVehicle.isActive,
              isCarfaxConnected: data.selectedVehicle.isCarfaxConnected,
              isMotorAndCarfaxSynced: data.selectedVehicle.isMotorAndCarfaxSynced,
              isMotorConnected: data.selectedVehicle.isMotorConnected,
              licensePlateNo: data.selectedVehicle.licensePlateNo || '',
              make: data.selectedVehicle.make,
              model: data.selectedVehicle.model,
              name: data.selectedVehicle.name,
              notes: data.selectedVehicle.notes || '',
              odmHistory: data.selectedVehicle.odmHistory || [],
              registrationState: data.selectedVehicle.registrationState || '',
              registrationStateCode: data.selectedVehicle.registrationStateCode || '',
              tags: data.selectedVehicle.tags || [],
              vehicleCheck: data.selectedVehicle.vehicleCheck,
              vehicleName: data.selectedVehicle.vehicleName,
              vin: data.selectedVehicle.VIN,
              year: data.selectedVehicle.year,
              vehicleId: data.selectedVehicle._id,
              title: data.selectedVehicle.vehicleName,
              vehicle: data.selectedVehicle.vehicleName,
              fullName: data.selectedVehicle.customerName,
              type: 'vehicle-add',
            };
          } else {
            this.vehicle = {
              ODM: data.selectedVehicle.ODM,
              VIN: data.selectedVehicle.VIN,
              apiResponse: data.selectedVehicle.apiResponse,
              color: { name: data.selectedVehicle.color || '' },
              connectedVia: data.selectedVehicle.connectedVia,
              _id: data.selectedVehicle.customerId,
              driveType: { name: data.selectedVehicle.driveType || '' },
              engine: data.selectedVehicle.engine,
              isActive: data.selectedVehicle.isActive,
              isCarfaxConnected: data.selectedVehicle.isCarfaxConnected,
              isMotorAndCarfaxSynced: data.selectedVehicle.isMotorAndCarfaxSynced,
              isMotorConnected: data.selectedVehicle.isMotorConnected,
              licensePlateNo: data.selectedVehicle.licensePlateNo || '',
              make: data.selectedVehicle.make,
              model: data.selectedVehicle.model,
              name: data.selectedVehicle.name,
              notes: data.selectedVehicle.notes || '',
              odmHistory: data.selectedVehicle.odmHistory || [],
              registrationState: data.selectedVehicle.registrationState || '',
              registrationStateCode: data.selectedVehicle.registrationStateCode || '',
              tags: data.selectedVehicle.tags || [],
              vehicleCheck: data.selectedVehicle.vehicleCheck,
              vehicleName: data.selectedVehicle.vehicleName,
              vin: data.selectedVehicle.VIN,
              year: data.selectedVehicle.year,
              vehicleId: data.selectedVehicle._id,
              title: data.selectedVehicle.vehicleName,
              vehicle: data.selectedVehicle.vehicleName,
              fullName: data.selectedVehicle.customerName,
              type: 'vehicle-add',
            };
          }

          if (data.selectedVehicle.transmission) {
            this.vehicle.transmission = { label: data.selectedVehicle.transmission === 'automatic' ? 'Automatic' : 'Manual', value: data.selectedVehicle.transmission || '' };
          }

          if (data.selectedVehicle.ODM && data.selectedVehicle.ODM.length) {
            let { reading, mileageMeasuringUnit } = data.selectedVehicle.ODM.pop();

            this.vehicle.mileage = `${reading || ''}`;

            if (reading) {
              if (!mileageMeasuringUnit) {
                mileageMeasuringUnit = this.defaultMileageUnit;
              }

              this.vehicle.mileageMeasuringUnit = find(mileageUnits, {
                value: mileageMeasuringUnit,
              });
            }
          }

          this.errors.vin = '';
          this.errors.licensePlateNo = '';
        }
        this.type = data.type;
        this.isDuplicateVehicle = true;
        this.errors.vin = '';
        this.errors.licensePlateNo = '';

        this.openVehicleInSidePanel(this.vehicle);
      }
    });
  }

  onProceed() {
    if (this.validation()) {
      const payloadData: any = {};
      const payload: any = this.createVehicleObject();

      if (this.vehicle?._id) {
        payload.vehicleId = this.vehicle._id;
      } else if (this.customer?._id && this.customerVehicle?._id) {
        payload.vehicleId = this.customerVehicle?._id;
      }

      payloadData.payload = payload;

      if (this.estimateId && this.estimateId != 'new-ro') {
        payloadData.estimateId = this.estimateId;
      }

      if (this.selectedVehicleTireSizes && this.selectedVehicleTireSizes.length) {
        [].map;
        payloadData.recommendedSizes = this.selectedVehicleTireSizes.map((size: any) => {
          return size?.label || '';
        });
      }

      this.onProceedQuickTireLookup.emit({
        data: payloadData,
        customerInfo: {
          isFleetCustomer: this.customer?.isFleetCustomer,
          isTaxCodeOverride: this.customer?.isTaxCodeOverride,
          taxExempt: this.customer?.taxExempt,
          customTaxCode: this.customer?.customTaxCode,
          selecteEstimateTax: this.selecteEstimateTax || {},
          isLaborRateOverride: this.customer?.isLaborRateOverride,
          isPricingMatrixOverride: this.customer?.isPricingMatrixOverride,
          customLaborRate: this.customer?.customLaborRate,
          customPartPricingMatrix: this.customer?.customPartPricingMatrix,
        },
      });
    } else {
      this.onProceedQuickTireLookup.emit({ data: null });
    }
  }

  handleOpenTransferVehicleDialog() {
    const ref = this.dialogService.open(TransferVehicleDialogComponent, {
      width: '740px',
      styleClass: 'add-dialog transfer-vehicle-dialog',
      showHeader: false,
      data: {
        customerList: this.customerList,
        customerId: this.customer._id,
        vehicleName: this.vehicle.title,
        currentCustomer: this.currentCustomer,
        isShow: false,
        isMFConnected: this.vehicle?.isMFConnected,
      },
    });

    const onClose = ref.onClose.subscribe((data) => {
      // if (data.type === 'close') {
      //   onClose.unsubscribe();
      // } else if (data.type === 'updateVehicle') {
      //   this.updateVehicleSidebar(data);
      // }
      if (data.type === 'updateVehicle') {
        this.updateVehicleSidebar(data);
      }
      onClose.unsubscribe();
    });
  }

  handleVehicleDuplication(vehicleData) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: `Vehicle duplication`,
        message: `This vehicle cannot be created as a new vehicle because it already exists under this customer's name. However, you can proceed by updating the existing information for this vehicle`,
        button: {
          success: { title: 'Change & update', styleClass: 'btn-danger' },
          cancel: { title: 'Go back' },
        },
        headerIcon: 'fas fa-exclamation font-icon-red font-white',
      },
    });

    const onClose = ref.onClose.subscribe((close: any) => {
      if (close.isSuccess) {
        const data = { selectedVehicle: vehicleData[0] };
        this.updateVehicle(vehicleData[0]);
        this.updateVehicleSidebar(data, true);
      }
      onClose.unsubscribe();
    });
  }

  updateVehicleSidebar(data, isVehicleDuplicate = false) {
    if (data.selectedVehicle) {
      if (this.from === 'quick-tire-lookup') {
        this.customer.fullName = data.selectedVehicle.customerName || data.selectedVehicle.currentCustomerName || this.customer.fullName;
        this.vehicle = {
          ODM: data.selectedVehicle.ODM,
          VIN: data.selectedVehicle.VIN,
          apiResponse: data.selectedVehicle.apiResponse,
          color: { name: data.selectedVehicle.color || '' },
          connectedVia: data.selectedVehicle.connectedVia,
          customerId: data.selectedVehicle.customerId,
          _id: data.selectedVehicle._id,
          driveType: { name: data.selectedVehicle.driveType || '' },
          engine: data.selectedVehicle.engine,
          isActive: true,
          isCarfaxConnected: data.selectedVehicle.isCarfaxConnected,
          isMotorAndCarfaxSynced: data.selectedVehicle.isMotorAndCarfaxSynced,
          isMotorConnected: data.selectedVehicle.isMotorConnected,
          licensePlateNo: data.selectedVehicle.licensePlateNo || '',
          make: data.selectedVehicle.make,
          model: data.selectedVehicle.model,
          name: data.selectedVehicle.name,
          notes: data.selectedVehicle.notes || '',
          odmHistory: data.selectedVehicle.odmHistory || [],
          registrationState: data.selectedVehicle.registrationState || '',
          registrationStateCode: data.selectedVehicle.registrationStateCode || '',
          tags: data.selectedVehicle.tags || [],
          vehicleCheck: data.selectedVehicle.vehicleCheck,
          vehicleName: data.selectedVehicle.vehicleName,
          vin: data.selectedVehicle.VIN,
          year: data.selectedVehicle.year,
          vehicleId: data.selectedVehicle._id,
          title: data.selectedVehicle.vehicleName,
          vehicle: data.selectedVehicle.vehicleName,
          fullName: data.selectedVehicle.customerName,
          type: 'vehicle-add',
        };
      } else {
        this.customer.fullName = data.selectedVehicle.customerName;
        this.vehicle = {
          ODM: data.selectedVehicle.ODM,
          VIN: data.selectedVehicle.VIN,
          apiResponse: data.selectedVehicle.apiResponse,
          color: { name: data.selectedVehicle.color || '' },
          connectedVia: data.selectedVehicle.connectedVia,
          _id: data.selectedVehicle.customerId,
          driveType: { name: data.selectedVehicle.driveType || '' },
          engine: data.selectedVehicle.engine,
          isActive: true,
          isCarfaxConnected: data.selectedVehicle.isCarfaxConnected,
          isMotorAndCarfaxSynced: data.selectedVehicle.isMotorAndCarfaxSynced,
          isMotorConnected: data.selectedVehicle.isMotorConnected,
          licensePlateNo: data.selectedVehicle.licensePlateNo || '',
          make: data.selectedVehicle.make,
          model: data.selectedVehicle.model,
          name: data.selectedVehicle.name,
          notes: data.selectedVehicle.notes || '',
          odmHistory: data.selectedVehicle.odmHistory || [],
          registrationState: data.selectedVehicle.registrationState || '',
          registrationStateCode: data.selectedVehicle.registrationStateCode || '',
          tags: data.selectedVehicle.tags || [],
          vehicleCheck: data.selectedVehicle.vehicleCheck,
          vehicleName: data.selectedVehicle.vehicleName,
          vin: data.selectedVehicle.VIN,
          year: data.selectedVehicle.year,
          vehicleId: data.selectedVehicle._id,
          title: data.selectedVehicle.vehicleName,
          vehicle: data.selectedVehicle.vehicleName,
          fullName: data.selectedVehicle.customerName,
          type: 'vehicle-add',
        };
      }

      if (data.selectedVehicle.transmission) {
        this.vehicle.transmission = { label: data.selectedVehicle.transmission === 'automatic' ? 'Automatic' : 'Manual', value: data.selectedVehicle.transmission || '' };
      }

      if (data.selectedVehicle.ODM && data.selectedVehicle.ODM.length) {
        let { reading, mileageMeasuringUnit } = data.selectedVehicle.ODM.pop();

        this.vehicle.mileage = `${reading || ''}`;

        if (reading) {
          if (!mileageMeasuringUnit) {
            mileageMeasuringUnit = this.defaultMileageUnit;
          }

          this.vehicle.mileageMeasuringUnit = find(mileageUnits, {
            value: mileageMeasuringUnit,
          });
        }
      }

      this.errors.vin = '';
      this.errors.licensePlateNo = '';
    }
    this.type = data.type;
    this.isDuplicateVehicle = true;
    this.errors.vin = '';
    this.errors.licensePlateNo = '';

    if (this.from === 'quick-tire-lookup') {
      this.onCustomerVehicleSelect(this.vehicle);
      this.isCreateVehicleMode = false;
      this.vehicleProcessingMode.emit(this.isCreateVehicleMode);
    } else {
      this.dataService.sendData(this.dataService.typePassData('vehicle-transfer', {}));
      this.vehicleCreated.emit({
        customer: {
          _id: this.customer._id,
          fullName: this.customer.fullName,
        },
        vehicle: {
          _id: this.vehicle.vehicleId,
          name: this.vehicle.name,
          vehicle: {
            ...this.vehicle,
            _id: this.vehicle.vehicleId,
          },
        },
        openFrom: this.openFrom,
        updateVehicleFlag: isVehicleDuplicate,
      });
    }
    this.openVehicleInSidePanel(this.vehicle);
  }

  openVehicleInSidePanel = (vehicelData) => {
    if (this.openFrom !== 'add-appointment' && this.from !== 'quick-tire-lookup') {
      this.dataService.sendData(this.dataService.typeSidebar('vehicle', vehicelData._id, vehicelData.fullName, vehicelData));
      this.closeDialog.emit({});
    }
  };

  createVehicle(vehicleData: any) {
    if (this.isProcessing) {
      return;
    }
    this.setProcessingState(true);
    this.httpService.createVehicles(vehicleData).then(
      (vehicle) => {
        if ((vehicle.apiResponse != null && !vehicle?.apiResponse?.BaseVehicleID) || (vehicle?.isMotorConnected && vehicle.apiResponse === null)){
          this.helperService.motorEventGenerator(vehicle, 'notFound', 'Motor: Vehicle Not Found');
        } else {
          if (vehicle?.apiResponse?.BaseVehicleID) {
            this.helperService.motorEventGenerator(vehicle, 'found', 'Vehicle Found - Motor');
            if (vehicle._id) {
              this.httpService.getVehicleFluidSpecifications(vehicle._id).then((data: any) => {
                if (!data.fliudSpecs || !data.fliudSpecs.length) {
                  this.helperService.motorEventGenerator(vehicle, 'notFound', 'Motor: Engine Specifications not Found');
                }
              });
            }
          }
        }
        if (vehicleData?.isMotorConnected) {
          this.helperService.motorEventGenerator(vehicle);
        }

        if (!vehicle.isMotorAndCarfaxSynced && this.from !== 'quick-tire-lookup') {
          this.openCustomerSidepanel(
            {
              ...vehicle.customer,
              _id: vehicle.customerId,
              isVehicleFetched: true,
            },
            vehicle,
          );
        } else {
          this.dataService.sendData(this.dataService.typeUpdate('vehile-side-list', 'vehicle', vehicle));
        }
        this.dataService.sendData(this.dataService.typeUpdate('customer-list', 'customer', {}));

        if (this.from === 'vehicle-side-list') {
          this.dataService.sendData(this.dataService.typeSidebar('vehicle', this.customer._id, this.customer.fullName, { _id: this.customer._id, vehicle, from: this.from }));
        }

        if (this.openFrom === 'add-vehicle') {
          if (this.from === 'quick-tire-lookup') {
            //this.customerVehicle = vehicle;
            this.onCustomerVehicleSelect(vehicle);
            this.isCreateVehicleMode = false;
            this.vehicleProcessingMode.emit(this.isCreateVehicleMode);
          } else {
            this.vehicleCreated.emit({
              customer: {
                _id: this.customer._id,
                fullName: this.customer.fullName,
              },
              vehicle: {
                _id: vehicle._id,
                name: vehicle.name,
                vehicle: vehicle,
              },
              openFrom: this.openFrom,
            });
          }
        } else {
          this.vehicleCreatedForOther.emit({
            customer: {
              ...this.customer,
            },
            vehicle: {
              _id: vehicle._id,
              name: vehicle.name,
              isActive: true,
              vehicle: vehicle,
            },
            openFrom: this.openFrom,
          });
          this.setProcessingState(false);
        }

        this.helperService.showToaster('success', messages.vehicleCreation);

        if (this.isOpenFromCreateCustomer) {
          this.dataService.sendData(
            this.dataService.typeAdd('vehicle-added', {
              vehicle,
              event: 'vehicle_created',
              followUps: vehicle.followUps,
              customerId: vehicle.customerId,
            }),
          );
        }

        if (vehicle.followUps && vehicle.followUps.length) {
          if (!this.isOpenFromCreateCustomer && this.from !== 'quick-tire-lookup') {
            this.dataService.sendData(
              this.dataService.typeFollowUp('RO', {
                vehicle,
                event: 'vehicle_created',
                followUps: vehicle.followUps,
                customerId: vehicle.customerId,
              }),
            );
          }
        }
      },
      (err) => {
        if (err.data.vinMatch > 0) {
          this.vinInputVisible = true;
          this.errors.vin = 'This VIN already exists,';
        }
        if (err.data.licenseMatch > 0) {
          this.licenseInputVisible = true;
          this.errors.licensePlateNo = 'This vehicle already exists,';
        }

        if (this.isTransferVehicleEnabled) {
          this.errors.transferVehicleError = `Vehicle already registered against customer`;
        }

        this.vinExsistErrMsg = err.data.vinMatch + (err.data.vinMatch === 1 ? ' vehicle match found' : ' vehicle matches found');
        this.lincencePlateErrMsg = err.data.licenseMatch + (err.data.licenseMatch === 1 ? ' vehicle match found' : ' vehicle matches found');
        this.vehicleAlreadyAdded = true;
        this.customerList = [];
        this.currentCustomer = err.data.currentCustomer;
        if (err.data.customers) {
          err.data.customers.forEach((c) => {
            if (c.vehicles) {
              c.vehicles.map((v) => {
                return (v.isChecked = false);
              });
            }
            this.customerList.push(c);
          });
          if (this.isTransferVehicleEnabled) {
            if (err.data.differentUser === false) {
              this.handleVehicleDuplication(err.data.customers[err.data.customers.length - 1].vehicles);
            } else if (err.data.differentUser || !err.data.differentUser) {
              this.handleOpenTransferVehicleDialog();
            }
          } else {
            this.openDuplicateVehicleModal();
          }
        }
        this.setProcessingState(false);

        if (typeof err === 'string') {
          this.helperService.showToaster('error', err);
        }
      },
    );
  }

  updateVehicle(data?: any) {
    if (this.isProcessing) {
      return;
    }
    this.setProcessingState(true);
    const {
      vin,
      year,
      make,
      model,
      color,
      mileage,
      driveType,
      transmission,
      registrationState,
      mileageMeasuringUnit,
      registrationStateCode,
      tags,
      customerId,
      _id,
      licensePlateNo,
      title,
      engine,
      isCarfaxConnected,
      vehicleName,
    } = this.vehicle;

    let odm: any = {};

    if (mileage) {
      odm = {
        reading: mileage,
        readingDate: this.dateService.currentDate(),
      };
      if (mileageMeasuringUnit && mileageMeasuringUnit.value) {
        odm.mileageMeasuringUnit = mileageMeasuringUnit.value;
      }
    }

    const updateVehicle = {
      ...this.helperService.deepCopy(data),
      ...this.helperService.deepCopy(this.vehicle),

      year: year || data.year,
      make: make || data.make,
      model: model || data.model,
      VIN: vin || data.VIN,
      licensePlateNo: licensePlateNo || data.licensePlateNo,
      registrationState: registrationState || data.registrationState,
      registrationStateCode: registrationStateCode || data.registrationStateCode,
      vehicle: vin || data.vehicle,
      name: `${year || ''} ${make || ''} ${model || ''}`,
      engine: engine || data.engine,
      title: title || data.title,
      isCarfaxConnected: isCarfaxConnected || data.isCarfaxConnected,
      vehicleName: vehicleName || data.vehicleName,
      ODM: [odm],
      tags: tags || data.tags || [],
      transmission: transmission?.value || data.transmission?.value,
      driveType: driveType?.name || data.driveType?.name,
      color: color?.name || data.color?.name,
      customerId: customerId || data.customerId,
      _id: _id || data._id,
    };

    this.httpService
      .updateVehicle(updateVehicle)
      .then(
        ({ isTagUpdated, followUps, customer, vehicle }) => {
          this.dataService.sendData(this.dataService.typeUpdate('customer-list', 'customer', {}));

          if (this.openFrom === 'add-vehicle') {
            this.vehicleCreated.emit({
              customer: {
                _id: this.customer._id,
                fullName: this.customer.fullName,
              },
              vehicle: {
                _id: vehicle._id,
                name: vehicle.name,
                vehicle: vehicle,
              },
              openFrom: this.openFrom,
            });
          } else {
            this.vehicleCreatedForOther.emit({
              customer: {
                _id: customer._id,
                fullName: this.customer.fullName,
              },
              vehicle: {
                _id: vehicle._id,
                name: vehicle.name,
                isActive: true,
                vehicle: vehicle,
              },
              openFrom: this.openFrom,
            });
            this.setProcessingState(false);
            this.helperService.showToaster('success', messages.vehicleInfoUpdate);
          }

          if (this.isOpenFromCreateCustomer) {
            this.dataService.sendData(
              this.dataService.typeAdd('vehicle-added', {
                vehicle,
                event: 'vehicle_created',
                followUps: followUps,
                customerId: customer._id,
              }),
            );
          }

          if (isTagUpdated && followUps && followUps.length) {
            if (!this.isOpenFromCreateCustomer) {
              this.dataService.sendData(
                this.dataService.typeFollowUp('RO', {
                  vehicle,
                  event: 'vehicle_created',
                  followUps: followUps,
                  customerId: customer._id,
                }),
              );
            }
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {});
  }

  onColorUpdate({ name, color, _id }, type: string) {
    const tag = {
      _id,
      color: color,
      type,
      name: name.trim(),
    };

    this.httpService.updateTag(tag).then(
      (data) => {
        for (let i = 0; i < this.vehicleColors.length; i++) {
          if (this.vehicleColors[i]._id === _id) {
            if (this.vehicle.color && this.vehicleColors[i].name === this.vehicle.color.name) {
              this.vehicle.color.name = name;
            }

            this.vehicleColors[i].name = name;
            break;
          }
        }

        for (let i = 0; i < this.vehicleColorsSuggestions.length; i++) {
          if (this.vehicleColorsSuggestions[i]._id === _id) {
            this.vehicleColorsSuggestions[i].name = name;
            break;
          }
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  onStateSelect({ state, stateCode }, triggerSearch: boolean = false) {
    this.vehicle.registrationState = state;
    this.vehicle.registrationStateCode = stateCode;
    this.vehicle.state = state;
    this.hasStateValueFilled = true;

    if (triggerSearch) {
      this.onSearchVehicle(this.vehicleQuery);
    }
  }

  onClear() {
    this.stateResults = [];
  }

  onStateSearch(search: string = '', country: string = '') {
    this.isStateSearching = true;
    this.httpService.stateSearch({ search, country }).then(
      (res) => {
        if (res.states) {
          this.stateResults = res.states;
        }
        this.isStateSearching = false;
      },
      (err) => {
        this.isStateSearching = false;
      },
    );
  }

  onDriveTypeUpdate({ name, color, _id }, type: string) {
    // Case-insensitive duplicate check
    const duplicate = this.driverTypeSuggestions.some((type) => type._id !== _id && type.name.toLowerCase() === name?.trim()?.toLowerCase());

    if (duplicate) {
      this.helperService.showToaster('error', 'Drive type already exists.');
      return;
    }
    const tag = {
      _id,
      color: color,
      type,
      name: name.trim(),
    };

    this.httpService.updateTag(tag).then(
      (data) => {
        for (let i = 0; i < this.driverTypes.length; i++) {
          if (this.driverTypes[i]._id === _id) {
            if (this.vehicle.driveType && this.driverTypes[i].name === this.vehicle.driveType.name) {
              this.vehicle.driveType.name = name;
            }

            this.driverTypes[i].name = name;
            break;
          }
        }

        for (let i = 0; i < this.driverTypeSuggestions.length; i++) {
          if (this.driverTypeSuggestions[i]._id === _id) {
            this.driverTypeSuggestions[i].name = name;
            break;
          }
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  onUpdateTags(data: any, type: string) {
    data.type = type;
    this.httpService.updateSupplier(data).then(
      (res) => {
        if (type === 'vehicle_color') {
          for (let i = 0; i < this.vehicleColors.length; i++) {
            if (this.vehicleColors[i]._id === data._id) {
              this.vehicleColors[i] = data;
            }
          }
        } else {
          for (let i = 0; i < this.driverTypes.length; i++) {
            if (this.driverTypes[i]._id === data._id) {
              this.driverTypes[i] = data;
            }
          }
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  scrollToTop(scrollHeight) {
    setTimeout(() => {
      try {
        this.addVehicleForm.nativeElement.scrollTop = scrollHeight;
      } catch (err) {}
    }, 100);
  }

  scrollToBottom() {
    setTimeout(() => {
      try {
        this.addVehicleForm.nativeElement.scrollTop = this.addVehicleForm.nativeElement.scrollHeight + 18;
      } catch (err) {}
    }, 100);
  }

  onTagSelect(tag: any) {
    if (!this.vehicle.tags) {
      this.vehicle.tags = [];
    }

    this.vehicle.tags.push(tag);
  }

  onTagDelete(tags: any[]) {
    this.vehicle.tags = tags;
  }

  onTagCreate(tag: any) {
    this.vehicleTags = [...this.vehicleTags, tag];
  }

  onTagFocus() {
    this.scrollToBottom();
  }

  handleOpenFleetCustomer() {
    let vinQuery = '';
    vinQuery = this.vehicle?.vin || this.vehicle?.vehicle || this.vehicle?.title;
    const vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/;
    if (!vinRegex.test(vinQuery)) {
      vinQuery = '';
    }
    const ref = this.dialogService.open(CreateMyFleetCustomerDialogComponent, {
      styleClass: 'add-dialog item-dialog new-part',
      showHeader: false,
      data: {
        fleetName: this.customer.firstName,
        fleetNumber: this.customer.fleetNumber,
        customer: this.customer,
        openFrom: 'vehicle',
        vinQuery,
        from: this.openFrom,
        isQuickTireLookup: this.from === 'quick-tire-lookup' ? true : false,
      },
    });
    const onClose = ref.onClose.subscribe((response: any) => {
      if (response.fleetNumber && this.openFrom !== 'add-appointment' && this.from !== 'quick-tire-lookup') {
        this.closeDialog.emit({});
      }

      if (this.from === 'quick-tire-lookup' && response?.vehicle) {
        this.onSearchCustomerVehicle(response.vehicle.name, false);
        this.onCustomerVehicleSelect(response.vehicle);
      }

      if (this.openFrom === 'add-appointment') {
        this.vehicleCreatedForOther.emit({
          customer: {
            _id: this.customer._id,
            fullName: this.customer.fullName,
          },
          vehicle: {
            _id: response.vehicle._id,
            name: response.vehicle.name,
            isActive: true,
            vehicle: response.vehicle,
          },
          openFrom: this.openFrom,
        });
      }
      onClose.unsubscribe();
    });
  }

  isMFCustomerHeaderButton() {
    if (!this.isCreateVehicleMode && this.customer?._id && this.customer?.isMFCustomer && !this.customerVehicle?._id) {
      return {
        btn: true,
        title: 'Create vehicle with MyFleetCenter',
        class: 'vehicle-fleet-btn',
        icon: 'assets/myFleetCenterIntegration-icon.svg',
      };
    }
    return {
      btn: false,
      title: '',
      class: '',
      icon: '',
    };
  }
}
